import styled from "styled-components";

const LinkComponent = styled("a")<{ bold?: boolean }>(({ theme, bold }) => ({
  color: theme.palette.common.black,
  ...(bold && {
    fontWeight: theme.typography.fontWeights.bold,
  }),

  "&:hover": {
    color: theme.palette.greys[600],
  },
}));

export default LinkComponent;
